export default "__VITE_ASSET__DTRjNmpD__"